/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AuditStatusEnum = 'FAILED' | 'NEW';

export const AuditStatusEnum = {

    FAILED: 'FAILED' as AuditStatusEnum,

    NEW: 'NEW' as AuditStatusEnum
};

